<svg:line
  [attr.x1]="p1[0]"
  [attr.y1]="p1[1]"
  [attr.x2]="p2[0]"
  [attr.y2]="p2[1]"
  [attr.cursor]="cursor$ | async"
  [style.display]="(cursor$ | async) ? undefined : 'none'"
  (mouseover)="handleMouseEvent($event)"
  (mouseout)="handleMouseEvent($event)"
  (mousedown)="handleMouseEvent($event)"
/>
